// App.js - Performance Optimized
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

// --- CRITICAL: Import these synchronously (No Lazy) ---
// Navbar is needed immediately for layout. Home_modern is your LCP element.
import Navbar from "./component/Navbar.jsx";
import Home_modern from './component/Home_modern.jsx';
import ScrollToTop from "./component/ScrollToTop.jsx"; // Tiny hook, keep sync

// --- LAZY: Non-critical components (loaded only when needed) ---
const Footer = lazy(() => import("./component/Footer.jsx"));
const RoutesForAllRoot = lazy(() => import("./component/RoutesForAllRoot.jsx"));

// Images/Data
import {
  CoverImage,
  resumeImages,
  techImages,
} from "./image/resumeData.js";

// Minimal Loader (Avoid Bootstrap dependency here to prevent layout shift)
const PageLoader = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      fontSize: "1.2rem",
      color: "#555",
    }}
  >
    <span>Loading...</span>
  </div>
);

// -------------------- Public Layout --------------------
function PublicLayout() {
  const location = useLocation();
  const shouldHideFooter = location.pathname.startsWith("/preview");

  return (
    // Move inline styles to CSS ideally, but keeping for now
    <div style={{ marginTop: "50px" }}>
      
      {/* 1. Navbar - Sync (Critical path) */}
      <Navbar />

      {/* 2. ScrollToTop - Sync (Tiny effect) */}
      <ScrollToTop />

      {/* 3. MAIN HOMEPAGE - Renders IMMEDIATELY, no waiting for other bundles */}
      <Routes>
        <Route
          path="/"
          element={
            <Home_modern
              images={resumeImages}
              techImages={techImages}
              CoverImage={CoverImage}
            />
          }
        />
      </Routes>

      {/* 4. SECONDARY ROUTES (e.g., /builder, /templates, /blog) 
           Lazy-loaded ONLY when user navigates to them.
           Using fallback={null} so it doesn't block the homepage. 
      */}
      <Suspense fallback={null}>
        <RoutesForAllRoot />
      </Suspense>

      {/* 5. FOOTER - Lazy-loaded (Non-critical, below the fold) */}
      {!shouldHideFooter && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}
    </div>
  );
}

// -------------------- App Root --------------------
function App() {
  return (
    <GoogleOAuthProvider clientId="1035406078589-pkn7kckbrrbtsqqogsfci47ajdh9hc25.apps.googleusercontent.com">
      
        <Router>
          {/*
            REMOVED the outer Suspense here.
            Now, when the user visits "/", React renders <PublicLayout> 
            instantly, which immediately renders <Home_modern>.
            No more waiting for RoutesForAllRoot!
          */}
          <Routes>
            <Route path="/*" element={<PublicLayout />} />
          </Routes>
        </Router>
    
    </GoogleOAuthProvider>
  );
}

export default App;